"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InactiveStatusType = void 0;
const typeorm_1 = require("typeorm");
const SupplierStatusType_1 = require("./SupplierStatusType");
let InactiveStatusType = class InactiveStatusType extends SupplierStatusType_1.SupplierStatusType {
    constructor(init) {
        super();
        if (init) {
            Object.assign(this, init);
        }
    }
};
exports.InactiveStatusType = InactiveStatusType;
exports.InactiveStatusType = InactiveStatusType = __decorate([
    (0, typeorm_1.ChildEntity)('inactive'),
    __metadata("design:paramtypes", [Object])
], InactiveStatusType);
